export default interface ValidationResult {
  valid: boolean;
  errors: string[];
}

export const VALID: ValidationResult = {
  valid: true,
  errors: [],
};

export const error = (message: string): ValidationResult => ({
  valid: false,
  errors: [message],
});
